import { ContractPricingIssuer } from '@/services/requests/users/Users.types';

export function getFixedPrice(issuer: ContractPricingIssuer) {
  return `${issuer.issuer.symbol}${issuer.conditions[0].value.valueFixed}`;
}

export function getFixedOrPercentPrice(issuer: ContractPricingIssuer, type: string): string {
  return `${issuer.conditions[0].value.valuePercent}%, ${type} ${getFixedPrice(issuer)}`;
}
